import { useFlag } from '@calendly/feature-check-react';
import { buildQuery } from '@calendly/http-tools';
import { I18n } from '@calendly/i18n';
import { Row, Cell } from '@calendly/table';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { forwardRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useHomeTabs } from 'hooks/home/tabs';
import { useMeetingIntelligenceFeatureFlag } from 'hooks/meeting_intelligence_awareness';
import { getDuration, getLocation, SelectCell, CreatedAt, CreatedAtWithLabel, Status, MainActionTableButton } from '../shared';
import { ActionButton } from './components/action_button';
import { DurationWithLocation } from './duration_with_location';
import { useOpenPollSidebar, getUniqInvitees } from './helpers';
import { Menu } from './menu';
import { RowDesktopNoWrap, RowActionButtonWrapper } from '../shared/styles';
const dividerCss = "dnkymoc";
const Divider = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(dividerCss, props.className)}>
      •
    </Component>;
});
const DurationWithLocationAndVotes = ({
  poll,
  inviteesCount
}) => {
  const {
    duration,
    locationConfigurations
  } = poll;
  const location = getLocation(locationConfigurations);
  const voteCountSummary = inviteesCount === 0 ? I18n.t('publisher.scheduling.polls.no_votes') : I18n.t('publisher.scheduling.polls.number_of_votes', {
    count: inviteesCount
  });
  return <BodyText color="muted" inline>
      <Divider />
      {getDuration(duration)}
      {location && <>
          <Divider />
          {location}
        </>}
      <Divider />
      {voteCountSummary}
    </BodyText>;
};
const nameWrapperCss = "nnndxpj";
const NameWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(nameWrapperCss, props.className)} />;
});
export const PollRow = ({
  poll,
  selectedRows,
  setSelectedRows
}) => {
  const openPollSidebar = useOpenPollSidebar(poll.id);
  const isDesktopUp = useDeviceType('isDesktopUp');
  const history = useHistory();
  const {
    getTabScopeV2,
    getMeetingsTabBasePath
  } = useHomeTabs();
  const {
    type: scopeType,
    id: scopeId
  } = getTabScopeV2();
  const isMIEnabled = useMeetingIntelligenceFeatureFlag();
  const hasNewMeetingsPage = useFlag('sa_new_meetings_page', false);
  const isNewMeetingsPageEnabled = isMIEnabled || hasNewMeetingsPage;
  const inviteesCount = getUniqInvitees(poll).length;
  const openEvent = event => {
    const {
      uuid,
      startTime
    } = event;
    const queryParams = {
      expand: true,
      period: moment(startTime).isBefore() ? 'past' : 'upcoming',
      uuid
    };
    const path = isNewMeetingsPageEnabled ? `${getMeetingsTabBasePath()}/${scopeType}/${scopeId}?selected=${event.uuid}` : `/app/scheduled_events/${scopeType}/${scopeId}${buildQuery(queryParams, {
      addQueryPrefix: true
    })}`;
    history.push(path);
  };
  const handleRowClick = () => {
    if (poll.status === 'booked') {
      openEvent(poll.event);
    } else {
      openPollSidebar();
    }
  };
  return <Row key={poll.id} onClick={() => handleRowClick(poll)}>
      <Cell>
        <SelectCell selectedRows={selectedRows} setSelectedRows={setSelectedRows} disabled={poll.status === 'booked'} rowId={poll.id} aria-label={I18n.t('publisher.components.table.select_item', {
        item: poll.name
      })} />
      </Cell>
      <Cell>
        <MainActionTableButton onClick={() => handleRowClick(poll)}>
          <NameWrapper>
            {poll.name}
          </NameWrapper>
        </MainActionTableButton>
        {isDesktopUp && <DurationWithLocation poll={poll} />}
      </Cell>
      <Cell>
        {isDesktopUp ? <RowDesktopNoWrap><CreatedAt createdAt={poll.createdAt} /></RowDesktopNoWrap> : <CreatedAtWithLabel createdAt={poll.createdAt} />}
      </Cell>
      <Cell>
        <RowDesktopNoWrap>
          <Status status={poll.status} />
          {!isDesktopUp && <DurationWithLocationAndVotes poll={poll} inviteesCount={inviteesCount} />}
        </RowDesktopNoWrap>
      </Cell>
      <Cell hideOnMobile>
        {inviteesCount}
      </Cell>
      <Cell align="right" hideOnMobile>
        <RowActionButtonWrapper><ActionButton poll={poll} /></RowActionButtonWrapper>
      </Cell>
      <Cell align="right" hasActions>
        <Menu poll={poll} fullActionsList={!isDesktopUp} />
      </Cell>
    </Row>;
};

require("./poll_row.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./poll_row.js");